/*
 * @Author: wsx
 * @Date: 2022-01-15 14:56:32
 * @LastEditTime: 2022-01-21 15:14:26
 * @LastEditors: your name
 * @Description:视频控件
 */
import client from "./videoClient";
export default {
  install: (app, options) => {
    app.config.globalProperties.$videoClient = client;
    app.provide("videoClient", client);
  }
};
